var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"input-usage","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-input',{attrs:{"messages":['Messages'],"append-icon":"close","prepend-icon":"phone"}},[_vm._v(" Default Slot ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }